import React from 'react'
import styled from 'styled-components'
import { appTheme } from '../../../config/styled'

const NotFoundJobOffersStyle = styled.div`
  text-align: center;
  margin: 60px 1rem 80px;

  @media ${props => props.theme.media.md} {
    margin: 60px 0 80px;
  }
`

const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1.6;
  margin-bottom: 10px;
  text-align: left;

  @media ${props => props.theme.media.sm} {
    text-align: center;
    margin-bottom: 40px;
  }
`

const Description = styled.p`
  color: #777777;
  font-size: 0.875rem;
  line-height: 1.71;
  text-align: left;

  @media ${props => props.theme.media.sm} {
    text-align: center;
  }
`

const Image = styled.img`
  width: 180px;
`

export const StyledNotFoundJobOffers: React.FC = () => {
  return (
    <NotFoundJobOffersStyle>
      <Title theme={appTheme}>お探しの条件のお仕事は見つかりませんでした。</Title>
      <Description theme={appTheme}>条件を変更するか、もう少し広い条件設定で検索してみてください。</Description>
    </NotFoundJobOffersStyle>
  )
}
